import { useApi, useSavings } from '@/api';
import { IconKpiCard, KpiSkeleton, Link } from '@/components';
import SavingsIcon from '@/components/icons/SavingsIcon';
import { Box, Flex, LinkWrapper, PercentageValue } from '@blockanalitica/ui';

export default function SavingsKpi({ days_ago }) {
  const [data, error] = useApi({
    url: `/save/`,
    queryParams: {
      days_ago: days_ago
    }
  });

  const [savings, savingsError] = useSavings(days_ago);

  if (error) {
    throw error;
  }
  if (savingsError) {
    throw savingsError;
  }
  if (data && savings) {
    return (
      <LinkWrapper
        to="/savings"
        // @ts-ignore
        as={Link}
        variant="kpiCardLinkWithBlendMode">
        <IconKpiCard
          leftIcon={<SavingsIcon size="6" />}
          title="Savings TVL"
          titleRight={
            <Flex fontSize="1" color="muted" alignItems="center" gap="3xs">
              <Box color="muted">APY:</Box>
              <Flex gap="2xs" color="white">
                <PercentageValue
                  value={data.rate}
                  options={{ tooltip: false }}
                />
              </Flex>
            </Flex>
          }
          field="total"
          data={savings}
          options={{ valueFontSize: '5', notation: 'compact' }}
        />
      </LinkWrapper>
    );
  }

  return <KpiSkeleton />;
}
